/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:64a49f7d-3c2a-4801-96bd-ce45fff1986c",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_JiPGES3xb",
    "aws_user_pools_web_client_id": "5ho3e12m6qmcodbe97fo82169k",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "swiftrise-storage120514-main",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
